import { DatePipe } from '@angular/common';
import { DATE_FORMATS } from './date-formats.constants';

export class DateUtils {

    static format(value: Date | string | null | undefined, isMobile: boolean, format?: string): string | null {
        if (!value) return null;

        const datePipe = new DatePipe('en-US');

        const dateFormat = format ?? (isMobile ? DATE_FORMATS.UI_MOBILE : DATE_FORMATS.UI_DESKTOP);
        return datePipe.transform(value, dateFormat);
    }
}
